class LocalDataService {
  
  static load_user_data(){
    let user =  this.loadData('user_info');
    
    return user || null;
  }

  static set_user_data(user_info){
    this.storeData('user_info', user_info);
  }
  
  // 存储推荐人ID
  static setReferrerId(userId) {
    if (userId) {
      this.storeData('referrer_user_id', userId);
    }
  }
  
  // 获取推荐人ID
  static getReferrerId() {
    return this.loadData('referrer_user_id') || 0;
  }

  static _pickFromBuckets(paramBuckets, keys) {
    for (const key of keys) {
      for (const bucket of paramBuckets) {
        const value = bucket.get(key);
        if (value !== null && String(value).trim() !== '') {
          return String(value).trim();
        }
      }
    }
    return '';
  }

  static _extractRedirectParams(redirectPath = '') {
    let redirectParams = new URLSearchParams();
    if (redirectPath === '') {
      return redirectParams;
    }

    let redirectSource = redirectPath;
    let redirectQueryIndex = redirectSource.indexOf('?');

    // URLSearchParams.get 已解码过一层；仅在整体仍为编码态且无法直接取 query 时再解一层。
    if (redirectQueryIndex < 0 && /%3[fF]/.test(redirectSource)) {
      try {
        redirectSource = decodeURIComponent(redirectSource);
        redirectQueryIndex = redirectSource.indexOf('?');
      } catch (_) {
        // ignore decode error
      }
    }

    if (redirectQueryIndex >= 0) {
      redirectParams = new URLSearchParams(redirectSource.slice(redirectQueryIndex + 1));
    }
    return redirectParams;
  }

  static _buildReferralParamContext(locationSearch = '', options = {}) {
    const includeRedirectRef = options.includeRedirectRef !== false;
    const safeWindow = typeof window !== 'undefined' ? window : null;
    const params = new URLSearchParams(locationSearch || '');
    const browserSearchParams = new URLSearchParams((safeWindow && safeWindow.location && safeWindow.location.search) || '');
    const hashValue = (safeWindow && safeWindow.location && safeWindow.location.hash) || '';
    const hashQueryIndex = hashValue.indexOf('?');
    const hashParams = hashQueryIndex >= 0
      ? new URLSearchParams(hashValue.slice(hashQueryIndex + 1))
      : new URLSearchParams();

    const outerBuckets = [params, hashParams, browserSearchParams];
    const redirectPath = this._pickFromBuckets(outerBuckets, ['redirect']);
    const redirectParams = includeRedirectRef ? this._extractRedirectParams(redirectPath) : new URLSearchParams();
    return { outerBuckets, redirectParams, redirectPath };
  }

  // 解析 referral 参数（兼容 search/hash/search + redirect 内嵌参数）
  static resolveReferralParams(locationSearch = '', options = {}) {
    const { outerBuckets, redirectParams, redirectPath } = this._buildReferralParamContext(locationSearch, options);
    // 归因优先级：外层 URL 明确参数 > redirect 内嵌 fallback。
    const outerRefCode = this._pickFromBuckets(outerBuckets, ['ref', 'ref_code']).toUpperCase();
    const redirectRefCode = this._pickFromBuckets([redirectParams], ['ref', 'ref_code']).toUpperCase();
    const refCode = outerRefCode || redirectRefCode;

    return {
      userId: this._pickFromBuckets(outerBuckets, ['user_id']),
      inviterId: this._pickFromBuckets(outerBuckets, ['from_user_id', 'inviter_id']),
      fromParam: this._pickFromBuckets(outerBuckets, ['from']),
      refCode,
      redirectPath
    };
  }

  // 获取访客ID（匿名设备级标识）
  static getOrCreateVisitorId() {
    const key = 'visitor_id';
    const existing = this.loadData(key);
    if (typeof existing === 'string' && existing.trim() !== '') {
      return existing.trim();
    }

    let nextId = '';
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      nextId = crypto.randomUUID().replace(/-/g, '');
    } else {
      nextId = `v_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    }
    this.storeData(key, nextId);
    return nextId;
  }
  
  // 获取剪映草稿路径
  static getDraftPath() {
    return this.loadData('draft_path');
  }

  // 写入剪映草稿路径
  static setDraftPath(path) {
    this.storeData('draft_path', path);
  }

  // 存储数据
  static storeData(key, data) {
    try {
      const serializedData = JSON.stringify(data);
      localStorage.setItem(key, serializedData);
    } catch (error) {
      console.error("Error saving data to localStorage", error);
    }
  }

  // 读取数据
  static loadData(key) {
    try {
      const serializedData = localStorage.getItem(key);
      if (serializedData === null) {
        return undefined;
      }
      return JSON.parse(serializedData);
    } catch (error) {
      console.error("Error loading data from localStorage", error);
      return undefined;
    }
  }

  // 删除数据
  static removeData(key) {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error("Error removing data from localStorage", error);
    }
  }

    // 记录空间列表
    static setSpaceList(spaces) {
      this.storeData('space_list', spaces);
    }
  
    // 获取空间列表
    static getSpaceList() {
      return this.loadData('space_list') || [];
    }
  
    // 增加空间
    static addSpace(title, hash,url) {
      const spaces = this.getSpaceList();
      spaces.push({ title, hash ,url});
      this.setSpaceList(spaces);
    }
  
    // 删除空间
    static removeSpace(hash) {
      let spaces = this.getSpaceList();
      spaces = spaces.filter(space => space.hash !== hash);
      this.setSpaceList(spaces);
    }

    // Save cookies associated with a specific space
  static saveCookies(hash, cookies) {
    try {
      const key = `cookie_data_${hash}`; // Unique key for each space's cookies
      this.storeData(key, cookies);
    } catch (error) {
      console.error("Error saving cookies to localStorage", error);
    }
  }

  // Get cookies associated with a specific space
  static getCookies(hash) {
    try {
      const key = `cookie_data_${hash}`; // Unique key for each space's cookies
      return this.loadData(key);
    } catch (error) {
      console.error("Error loading cookies from localStorage", error);
      return null;
    }
  }

  // 获取当前用户ID
  static getCurrentUserId() {
    const user = this.load_user_data();
    return user && user.id ? user.id : null;
  }
  
  // 为链接添加user_id参数
  static addUserIdToLink(link) {
    const userId = this.getCurrentUserId();
    if (!userId) return link;
    
    // 检查链接是否已经有参数
    const hasParams = link.includes('?');
    // 检查链接是否已经有user_id参数
    const hasUserId = link.includes('user_id=');
    
    if (hasUserId) return link; // 如果已经有user_id，不做改变
    
    const separator = hasParams ? '&' : '?';
    return `${link}${separator}user_id=${userId}`;
  }

  // 官方动态缓存管理
  static getOfficialNotificationCount() {
    try {
      const count = localStorage.getItem('official_notification_count');
      return count ? parseInt(count, 10) : 0;
    } catch (error) {
      console.error('获取官方动态计数失败:', error);
      return 0;
    }
  }

  static setOfficialNotificationCount(count) {
    try {
      localStorage.setItem('official_notification_count', count.toString());
    } catch (error) {
      console.error('设置官方动态计数失败:', error);
    }
  }

  static hasNewOfficialNotifications(currentCount) {
    const cachedCount = this.getOfficialNotificationCount();
    return currentCount > cachedCount;
  }

}

export default LocalDataService;
